<template>
  <div class="book_content_container">
    <div class="book_content_header">
      <div class="book_content_text">
        <h1>Confirming quote</h1>
        <p>
          Please, select a level and then confirm your choice in the opening
          mode
        </p>
      </div>
    </div>
    <section v-if="loading" class="book_content_body">
      <BookLevelCardSkeleton v-for="n in 3" :key="n" />
    </section>
    <b-tabs
      v-if="!loading && pricesLevels.length > 0"
      v-model="activeTab"
      position="is-right"
      class="block mb-0"
      :is-nav-hidden="isOnlyOneType"
    >
      <b-tab-item
        v-for="price in pricesLevels"
        :key="price.id"
        :label="price.label"
      >
        <section class="book_content_body">
          <BookLevelCard
            v-for="level in price.prices"
            :key="level.id"
            :price="price"
            :level="level"
            :selected-level="selectedLevel"
            :selected-price="selectedPrice"
            :is-disabled-to-update="isLevelDisabledToConfirm"
            @selectLevel="selectLevel"
          />
        </section>
      </b-tab-item>
    </b-tabs>
    <p
      v-if="!loading && pricesLevels.length === 0"
      class="book_content_placeholder"
    >
      There is no price available for this itinerary, please add services to
      your quote
    </p>
    <BaseModal :is-component-modal-active="showStatusChangeModal">
      <IconWarning slot="icon" class="icon is-xsmall color-12" />
      <span slot="title"
        >Are you sure to
        <span class="has-text-weight-semibold">change</span> this status?
      </span>
      <div slot="buttons" class="is-flex">
        <BaseButton
          action="secondary"
          size="medium"
          class="mr-4"
          @click="closeModal"
        >
          <p slot="text">No, take me back</p>
        </BaseButton>
        <BaseButton
          action="tercery"
          size="medium"
          :disabled="loading"
          @click="
            () => {
              this.closeModal();
              this.validateItineraryIsPublished(
                this.constants.ITINERARY_STATUS.CONFIRM.value
              );
            }
          "
        >
          <p slot="text">Yes, continue</p>
        </BaseButton>
      </div>
    </BaseModal>

    <BaseModal :is-component-modal-active="showIsItineraryPublishedModal">
      <IconWarning slot="icon" class="icon is-xsmall color-12" />
      <span slot="title">
        This itinerary has not been published yet. Then you will not be able to
        edit the export.
        <br />Are you sure to
        <span class="has-text-weight-semibold">change</span> this status?
      </span>
      <div slot="buttons" class="is-flex">
        <BaseButton
          action="secondary"
          size="medium"
          :disabled="loading"
          class="mr-4"
          @click="
            () => {
              showStatusChangeModal = false;
              showIsItineraryPublishedModal = false;
              redirectToExportSection();
            }
          "
        >
          <p slot="text">No, redirect to export</p>
        </BaseButton>
        <BaseButton
          action="tercery"
          size="medium"
          :disabled="loading"
          @click="
            () => handleChangeStatus(constants.ITINERARY_STATUS.CONFIRM.value)
          "
        >
          <p slot="text">Yes, continue</p>
        </BaseButton>
      </div>
    </BaseModal>

    <ExternalExportModal
      :is-modal-open="showExternalExportModal"
      :loading="loading"
      :on-external-export-continue="onExternalExportContinue"
      :close-modal="closeChangeStatusModal"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BookLevelCard from "./BookLevelCard/BookLevelCard.vue";
import BookLevelCardSkeleton from "./BookLevelCard/BookLevelCardSkeleton.vue";
import ExternalExportModal from "@/components/quote-views/_shared/ExternalExportModal.vue";
import { SERVICE_STATUS } from "@/constants";
import {
  ITINERARY_STATUS_TO_PUBLISH_QUOTE,
  ITINERARY_STATUS,
  QUOTES_STATUS,
} from "@/constants/itinerary";
import { PATH_INFO } from "@/router/path";
import { helper } from "@/utils/itinerary";

export default {
  name: "BookContent",
  components: {
    BookLevelCard,
    BookLevelCardSkeleton,
    ExternalExportModal,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    loadServicesItinerary: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      constants: {
        ITINERARY_STATUS,
      },
      selectedLevel: {
        id: null,
      },
      selectedPrice: {
        id: null,
      },
      selectLevelServices: [],
      activeTab: 0,
      showStatusChangeModal: false,
      showIsItineraryPublishedModal: false,
      showExternalExportModal: false,
    };
  },
  computed: {
    ...mapGetters({
      prices: "itinerary/getPricesItinerariesSource",
      itinerary: "itinerary/getItinerary",
      quoteStatus: "itinerary/getItineraryStatus",
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      published_images_config: "itinerary/getPublishedConfigAndImages",
      hasAccountOnOtherSystem: "itinerary/getHasAccountOnOtherSystem",
      isEnabledByTenant: "itinerary/getIsEnabledByTenant",
    }),
    isOnlyOneType() {
      return this.prices?.length === 1;
    },
    pricesLevels() {
      return this.prices.map((price) => {
        return {
          ...price,
          isPriceSelected:
            price.selected_level !== 0 && price.selected_level !== null,
        };
      });
    },
    isDisabledToUpdate() {
      const priceFound = this.pricesLevels.find(
        (price) => price.isPriceSelected
      );
      return priceFound !== undefined;
    },
    isLevelDisabledToConfirm() {
      const disableQuoteByStatus = !helper.hasStatus(this.quoteStatus, [
        QUOTES_STATUS.SENT.id,
        QUOTES_STATUS.READY_TO_SELL.id,
      ]);

      return (
        this.isDisabledToUpdate ||
        this.hideElementByCondition ||
        disableQuoteByStatus
      );
    },
  },
  watch: {
    pricesLevels() {
      const priceSelected = this.pricesLevels?.find(
        (price) => price.isPriceSelected
      );
      this.selectedPrice = priceSelected || { id: null };
      this.selectedLevel = priceSelected?.prices?.find(
        (level) => level.level === priceSelected?.selected_level
      ) || { id: null };
      this.activeTab =
        this.pricesLevels?.findIndex((price) => price.isPriceSelected) || 0;
    },
  },
  methods: {
    redirectToExportSection() {
      this.$router.push({
        path: PATH_INFO.EXPORT.path,
        query: { itinerary: this.$route.query.itinerary },
      });
    },
    async validateItineraryIsPublished(
      newStatus,
      forceSaving = false,
      externalSource = ""
    ) {
      const isItineraryPublished = this.published_images_config.config?.id;
      if (
        !forceSaving &&
        !isItineraryPublished &&
        ITINERARY_STATUS_TO_PUBLISH_QUOTE.includes(newStatus)
      ) {
        this.showStatusChangeModal = false;
        this.showIsItineraryPublishedModal = true;
      } else {
        this.setLoading(true);
        if (forceSaving) await this.confirmQuote(externalSource);
        else await this.handleChangeStatus(newStatus, externalSource);
        const payload = {
          id: this.$route.query.itinerary,
          reload: true,
          from: this.itinerary.data.start_date,
          to: this.itinerary.data.end_date,
        };
        await this.loadServicesItinerary(payload);
        this.setLoading(false);
      }
    },
    async onExternalExportContinue(externalSource = "") {
      this.closeChangeStatusModal();
      await this.$store.dispatch("itinerary/setIsRecentlyExported", true);
      await this.validateItineraryIsPublished(
        ITINERARY_STATUS.CONFIRM.value,
        true,
        externalSource
      );
      await this.$store.dispatch("itinerary/setIsRecentlyExported", false);
    },
    async handleChangeStatus(newStatus, externalSource = "") {
      if (
        newStatus === ITINERARY_STATUS.CONFIRM.value &&
        this.hasAccountOnOtherSystem
      ) {
        this.showStatusChangeModal = false;
        this.showIsItineraryPublishedModal = false;
        this.showExternalExportModal = true;
        return;
      }
      await this.confirmQuote(externalSource);
    },
    closeChangeStatusModal() {
      this.showStatusChangeModal = false;
      this.showExternalExportModal = false;
      this.showIsItineraryPublishedModal = false;
    },
    getQuotePayload(defaultPayload = {}) {
      return {
        ...defaultPayload,
        id: this.itinerary?.data?.id,
        status: ITINERARY_STATUS.CONFIRM.value,
        prices_list: this.pricesLevels.map((price) => {
          return {
            ...price,
            selected_level:
              price.id === this.selectedPrice.id ? this.selectedLevel.level : 0,
          };
        }),
      };
    },
    closeModal() {
      this.showStatusChangeModal = false;
    },
    selectLevel({ level = {}, services = [], price = {} }) {
      this.selectedLevel = level;
      this.selectedPrice = price;
      this.selectLevelServices = services;
      this.showStatusChangeModal = true;
    },
    async confirmQuote(externalSource = "") {
      this.setLoading(true);
      this.showStatusChangeModal = false;
      this.showIsItineraryPublishedModal = false;

      const payload = this.getQuotePayload({
        cur_step: 1,
        last_step: 1,
        source: externalSource,
      });

      try {
        await this.$store.dispatch("itinerary/change_status", payload);
      } catch (error) {
        this.setLoading(false);
        this.$buefy.toast.open({
          duration: 5000,
          message: error.message,
          position: "is-top",
          type: "is-danger",
        });
      }

      this.setLoading(false);
    },
    async confirmQuoteServices(cur_step = 0, last_step = 0) {
      const payload = {
        id: this.itinerary?.data?.id,
        status: SERVICE_STATUS.CONFIRM.value,
        services: this.selectLevelServices.map((service) => service.id),
        cur_step,
        last_step,
      };
      await this.$store.dispatch("itinerary/change_status_services", payload);
    },
    setLoading(value) {
      this.$emit("updateLoading", value);
    },
  },
};
</script>
<style>
.book_content_container {
  padding: 0 1.5rem 0 0;
}
.book_content_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.book_content_header button > p {
  padding-right: 0.5rem;
}
.book_content_text > h1 {
  font-size: 1.5rem;
  font-weight: 800;
}
.book_content_text > p {
  margin-top: 1rem;
}
.book_content_body {
  display: flex;
  margin: 4rem 0;
  align-items: flex-start;
  justify-content: center;
  column-gap: 2rem;
}
.book_content_container :is(.b-tabs) {
  top: -4rem;
  position: relative;
}
.book_content_container > .b-tabs .tabs :is(li, a) {
  color: #1d3b83;
  border-color: #1d3b83;
}
.book_content_container > .b-tabs .tabs li.is-active a {
  background: #1d3b83;
  color: #fff;
  border-radius: 0.25rem;
}
.book_content_placeholder {
  text-align: center;
  margin-top: 5rem;
  font-size: 1rem;
  font-weight: 500;
  color: #4a4a4a;
}
.book_content_container :is(.b-tabs[is-nav-hidden="true"] > nav) {
  opacity: 0;
  pointer-events: none;
}

@media screen and (max-width: 480px) {
  .book_content_container {
    padding: 0rem;
  }

  .b-tabs .tab-content {
    padding: 0rem;
  }

  .book_content_body {
    flex-direction: column;
    row-gap: 2rem;
  }

  .book_level_card {
    width: 100%;
  }

  .book_level_card body {
    margin-top: 1rem;
    height: 10rem;
    overflow-y: auto;
  }
}
</style>
